import React from "react";
import fetchJson from "lib/fetchJson";
import { client_system_uri } from 'config';
import Head from 'next/head';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faUserAlt, faEnvelopeCircleCheck } from '@fortawesome/free-solid-svg-icons';

export default function Contact() {

  const sessionLogoutHandle = () => {
    fetchJson( `${ client_system_uri }/api/logout`, { method: "get" } );
    console.log( '[page] logout ' );
  };

  let pageTitle = "Contact:USOM";
  let pageDescription = "USOMへのお問い合わせはこちらから";
  return (
    <section className="container">
      <div className="page_content_wrap">
        <Head>
          <title>{ pageTitle }</title>
          <meta name="viewport" content="initial-scale=1.0, width=device-width"/>
          <meta name="description" content={ pageDescription }/>
        </Head>

        <aside style={ { padding: "4rem 0", textAlign: "center" } }>
          <h1><FontAwesomeIcon style={ { marginRight: "0.5rem" } } icon={ faEnvelopeCircleCheck }/> Contact</h1>
        </aside>

        <aside style={ { padding: "4rem 0", textAlign: "center" } }>
          <h3>問い合わせ先</h3>
          <p><FontAwesomeIcon style={ { marginRight: "0.5rem" } } icon={ faEnvelope }/>
            boq4thqk82@kwonwe.com
          </p>
          <span className={ "txt_small" }>
          お気づきな点などありましたらお知らせいただければ幸いです
        </span>
        </aside>

        <aside style={ { padding: "4rem 0", textAlign: "center" } }>
          <h3>FAQ セッションのリセット</h3>
          <span className={ "txt_small" }> 何か不都合がありそうな時には、こちらからセッションのリセットを行うことができます。 </span>
          <button className={ "button_simple" } onClick={ sessionLogoutHandle }>delete Session</button>
        </aside>

      </div>
    </section>
  );
}
